define("AuctionClocks",function (){

  var is_on_list_page = true;
  var almost_lastminute = 300;

  function doOnCounterTick(periods) {
    var remaining = $.countdown.periodsToSeconds(periods);

    // update countdown bars
    if ($(this).data('countdown-bar')) {
      countdownBars.updateBar(
        $(this).data('countdown-bar'),
        (new Date($(this).data('countdown')._until).getTime() / 1000) - $(this).attr('data-start'),
        remaining
      );
    }

    // highlight last minute
    if (remaining < 59 && !$(this).data('lot_state_lastminute_set')) {
      $(this).data('lot_state_lastminute_set', 'true');
      var el = null;
      if (is_on_list_page) {
        el = $(this).closest('.cw-item-auctionlot')
      }
      else {
        el = $(this).closest('.bid_block');
        if (typeof window.targetAbGoal !== "undefined") {
          window.targetAbGoal.setGoal('bid_placed_lastminute');
        }
      }
      el.addClass('lot_state_lastminute');
    } else if (remaining >= 59 && $(this).data('lot_state_lastminute_set')) {
      $(this).data('lot_state_lastminute_set', null);
      var el = null;
      if (is_on_list_page) {
        el = $(this).closest('.cw-item-auctionlot')
      }
      else {
        el = $(this).closest('.bid_block');
        if (typeof window.targetAbGoal !== "undefined") {
          window.targetAbGoal.removeGoal('bid_placed_lastminute');
        }
      }
      el.removeClass('lot_state_lastminute');
    }

    // On lot page also do things when "almost last minute" (currently last 5 minutes)!
    if (!is_on_list_page) {
      if (remaining < almost_lastminute && !$(this).data('lot_state_almost_lastminute_set')) {
        $(this).data('lot_state_almost_lastminute_set', 'true');
        $(this).closest('.bid_block').addClass('lot_state_almost_lastminute');
        if (typeof window.targetAbGoal !== "undefined") {
          window.targetAbGoal.setGoal('auction_extension_info_bid');
        }
        // Show hint when user has never placed a bid before
        if (typeof(cw_store) !== 'undefined' && cw_store.enabled && cw_store.get('has_placed_bids') === 'false') {
          var $hint = $('#js-almost-lastminute-hint');
          if (typeof window.inlineHints !== "undefined" && $hint.length && !$hint.hasClass('open')) {
            if (typeof window.matchMedia === "function" && window.matchMedia("(max-width: 746px)").matches) {
              $hint.removeClass('left').addClass('bottom');
            }
            if (typeof(AB) !== "undefined" && AB !== null && AB.test('auction_extension_info') === "B") {
              setTimeout(function() {
                window.inlineHints.openHint($hint);
              }, 2000);
            }
          }
        }
      } else if (remaining >= almost_lastminute && $(this).data('lot_state_almost_lastminute_set')) {
        // Unlikely scenario at the moment, as once it's the last 5 minutes, it will never be more
        // than 5 minutes. Unless we set the bid prolongation time to more than 4 minutes.
        $(this).data('lot_state_almost_lastminute_set', null);
        $(this).closest('.bid_block').removeClass('lot_state_almost_lastminute');
        if (typeof window.targetAbGoal !== "undefined") {
          window.targetAbGoal.removeGoal('auction_extension_info_bid');
        }
      }
    }
  }



  var countdownBars = {
    // bar is divided in 4 parts, that all get a division of the bar:
    // last 2 minutes / last hour / last day / auction duration
    ranges: [120, 3600, 86400],
    divisions: [1/2, 1/6, 1/6, 1/6], // Should add up to 1!
    animateFrom: 58, // seconds to go when animation effect should start
    init: function($counters) {
      $counters.each(function() {
        // Create the bar
        var $fill = $('<div/>').addClass('c-countdown-bar__fill');
        var $bar = $('<div/>').addClass('c-countdown-bar').append($fill).data('fill', $fill);
        // Attach the bar to the counter
        $(this).data('countdown-bar', $bar).closest('.counter_container').append($bar);
        // $bar is updated every second (counter.onTick) from doOnCounterTick
      });
    },
    updateBar: function($bar, duration, remaining) {
      if (remaining > duration) {
        var bar_length = '100%';
      } else if (remaining > 0) {
        if (remaining <= this.animateFrom) {
          if (!$bar.data('animate_set')) {
            $bar.addClass('c-countdown-bar--animate').data('animate_set', true);
          }
        } else if ($bar.data('animate_set')) {
          $bar.removeClass('c-countdown-bar--animate').data('animate_set', null);
        }
        if (remaining < this.ranges[0]) {
          var fraction = (remaining / this.ranges[0]) * this.divisions[0];
        } else if (remaining < this.ranges[1]) {
          var fraction = this.divisions[0] + ((remaining - this.ranges[0]) / this.ranges[1]) * this.divisions[1];
        } else if (remaining < this.ranges[2]) {
          var fraction = this.divisions[0] + this.divisions[1] + ((remaining - this.ranges[1]) / this.ranges[2]) * this.divisions[2];
        } else {
          var fraction = this.divisions[0] + this.divisions[1] + this.divisions[2] + ((remaining - this.ranges[2]) / duration) * this.divisions[3];
        }
        var bar_length = (Math.round(fraction * 1000) / 10) + '%';
      } else {
        var bar_length = 0;
      }
      $bar.data('fill').css('width', bar_length);
    }
  }



  function serverTime() {
    var time = null;
    $.ajax({
      url: '/buyer/api/v1/auctions/time',
      async: false, dataType: 'json',
      cache: false,
      success: function(response) {
        time = new Date(response.time *1000);
        try {
          window.serverTimeOffset = (time.valueOf() - new Date().valueOf());
        }
        catch(e) {
          return true;
        }
      }, error: function(http, message, exc) {

        window.console && console.log && console.log('Could not fetch time', message);
        time = new Date();
        setTimeout(function(){
           window.location.reload();
        }, 5000);

    }});

    return time;
  }



  function setup_without_clocks(callback) {
    $("span.state.bidding_starts_at").hide();
    $("span.state.bidding_ends_at").hide();
    $(".lot_state_bidding_started span.state.lot_closes_at").css("display","block");
    $(".lot_state_bidding_started .countdown").hide();
    $(".lot_state_bidding_started .closing_time").show();
    $(".lot_state_bidding_not_started span.state.lot_closes_at").css("display","block");
    $(".lot_state_bidding_not_started .closing_time").show();
    callback();
  }



  function setup_with_clocks(callback, expiry_callback) {
    if (typeof(AB) != "undefined" && AB != null && AB.test('updated_countdown') == 'B') {
      setup_with_clocks_b_variant(callback, expiry_callback);
    } else {
      if ($.countdown_old !== undefined) {
        // Assign v1.6.1 to $.countdown
        $.countdown = $.countdown_old;
        $.fn.countdown = $.fn.countdown_old;
      }
      setup_with_clocks_a_variant(callback, expiry_callback);
    }
  }



  function setup_with_clocks_a_variant(callback, expiry_callback) {
    // Add clock
    $.countdown.regional['en'] = {
      labels: ['Years', 'Months', 'Weeks', 'Days', 'Hours', 'Minutes', 'Seconds'],
      labels1: ['Year', 'Month', 'Week', 'Day', 'Hour', 'Minute', 'Second'],
      compactLabels: ['y', 'm', 'w', 'd', 'h', 'm', 's']
    };
    $.countdown.regional['nl'] = {
      labels: ['Jaren', 'Maanden', 'Weken', 'Dagen', 'Uren', 'Minuten', 'Seconden'],
      labels1: ['Jaar', 'Maand', 'Week', 'Dag', 'Uur', 'Minuut', 'Seconde'],
      compactLabels: ['j', 'm', 'w', 'd', 'u', 'm', 's']
    };
    $.countdown.regional['fr'] = {
      labels: ['Années', 'Mois', 'Semaines', 'Jours', 'Heures', 'Minutes', 'Secondes'],
      labels1: ['Année', 'Mois', 'Semaine', 'Jour', 'Heure', 'Minute', 'Seconde'],
      compactLabels: ['a', 'm', 's', 'j','h','m','s'],
      whichLabels: function(amount) {
        return (amount > 1 ? 0 : 1);
      },
      digits: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
      timeSeparator: ':', isRTL: false
    };
    $.countdown.regional['de'] = {
      labels: ['Jahre', 'Monate', 'Wochen', 'Tage', 'Stunden', 'Minuten', 'Sekunden'],
      labels1: ['Jahr', 'Monat', 'Woche', 'Tag', 'Stunde', 'Minute', 'Sekunde'],
      compactLabels: ['&#8202;J', '&#8202;M', '&#8202;W', '&#8202;Tage','&#8202;h','&#8202;min','&#8202;s'],
      compactLabels1: ['&#8202;J', '&#8202;M', '&#8202;W', '&#8202;Tag','&#8202;h','&#8202;min','&#8202;s'],
      whichLabels: function(amount) {
        return (amount > 1 ? 0 : 1);
      },
      digits: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
      timeSeparator: ':', isRTL: false
    };
    $.countdown.regional['it'] = {
      labels: ['Anni', 'Mesi', 'Settimane', 'Giorni', 'Ore', 'Minuti', 'Secondi'],
      labels1: ['Anno', 'Mese', 'Settimana', 'Giorno', 'Ora', 'Minuto', 'Secondo'],
      compactLabels: ['a.', 'm', 'set.', 'g', 'h', 'm', 's']
    };
    $.countdown.regional['es'] = {
      labels: ['Años', 'Meses', 'Semanas', 'Días', 'Horas', 'Minutos', 'Segundos'],
      labels1: ['Año', 'Mes', 'Semana', 'Día', 'Hora', 'Minuto', 'Segundo'],
      compactLabels: ['a.', 'm', 'sem.', 'd', 'h', 'm', 's']
    };
    $.countdown.regional['zh_CN'] = {
      labels: ['年', '月', '周', '天', '小时', '分', '秒'],
      labels1: ['年', '月', '周', '天', '小时', '分', '秒'],
      compactLabels: ['年', '月', '周', '天', '小时', '分', '秒']
    };
    $.countdown.regional['zh_TW'] = {
      labels: ['年', '月', '周', '天', '小時', '分', '秒'],
      labels1: ['年', '月', '周', '天', '小時', '分', '秒'],
      compactLabels: ['年', '月', '周', '天', '小時', '分', '秒']
    };
    $.countdown.regional['pt'] = {
      labels: ['Years', 'Months', 'Weeks', 'Days', 'Hours', 'Minutes', 'Seconds'],
      labels1: ['Year', 'Month', 'Week', 'Day', 'Hour', 'Minute', 'Second'],
      compactLabels: ['y', 'm', 'w', 'd', 'h', 'm', 's']
    };
    $.countdown.regional['da'] = {
      labels: ['Years', 'Months', 'Weeks', 'Days', 'Hours', 'Minutes', 'Seconds'],
      labels1: ['Year', 'Month', 'Week', 'Day', 'Hour', 'Minute', 'Second'],
      compactLabels: ['y', 'm', 'w', 'd', 't', 'm', 's']
    };
    $.countdown.regional['sv'] = {
      labels: ['Years', 'Months', 'Weeks', 'Days', 'Hours', 'Minutes', 'Seconds'],
      labels1: ['Year', 'Month', 'Week', 'Day', 'Hour', 'Minute', 'Second'],
      compactLabels: ['y', 'm', 'w', 'd', 't', 'm', 's']
    };
    $.countdown.regional['no'] = {
      labels: ['Years', 'Months', 'Weeks', 'Days', 'Hours', 'Minutes', 'Seconds'],
      labels1: ['Year', 'Month', 'Week', 'Day', 'Hour', 'Minute', 'Second'],
      compactLabels: ['y', 'm', 'w', 'd', 't', 'm', 's']
    };
    $.countdown.regional['pl'] = {
      labels: ['Years', 'Months', 'Weeks', 'Days', 'Hours', 'Minutes', 'Seconds'],
      labels1: ['Year', 'Month', 'Week', 'Day', 'Hour', 'Minute', 'Second'],
      compactLabels: ['y', 'm', 'w', 'd', 'h', 'm', 's']
    };

    var host = window.location.host,
        countdownLocale = 'en';

    if      (host.match(/.*\.nl$/)) { countdownLocale = 'nl'; }
    else if (host.match(/.*\.it$/)) { countdownLocale = 'it'; }
    else if (host.match(/.*\.es$/)) { countdownLocale = 'es'; }
    else if (host.match(/.*\.cn$/)) { countdownLocale = 'zh_CN'; }
    else if (host.match(/.*\.hk$/)) { countdownLocale = 'zh_TW'; }
    else if (host.match(/.*\.de$/)) { countdownLocale = 'de'; }
    else if (host.match(/.*\.pt$/)) { countdownLocale = 'pt'; }
    else if (host.match(/.*\.dk$/)) { countdownLocale = 'da'; }
    else if (host.match(/.*\.se$/)) { countdownLocale = 'sv'; }
    else if (host.match(/.*\.no$/)) { countdownLocale = 'no'; }
    else if (host.match(/.*\.pl$/)) { countdownLocale = 'pl'; }
    else if (host.match(/.*\.fr$/) ||
      host.match(/.*\.eu$/)) { countdownLocale = 'fr'; }
    else if (host.match(/.*\.com$/) ||
      host.match(/.*\.co.uk$/)) { countdownLocale = 'en'; }

    $.countdown.setDefaults($.countdown.regional[countdownLocale]);

    var clockLayout = '{d<}{dn}{dl} {d>}{h<}{hn}{hl} {h>}{m<}{mnn}{ml} {m>}{snn}{sl}';
    var elems = $("#lot_list div.cw-item-auctionlot:not(.deactivated,.lot_state_closed) span.counter, #cw-main section.bid_block:not(.deactivated) strong.counter, #cw-main section.bid_block.deactivated.lot_state_highest_bid_offer strong.counter, #suggested_lots span.counter");
    elems.each(function() {
      var counter = $(this);
      if (!counter.attr('data-lot-closed-at') && counter.attr("data-until")) {
        counter.countdown({
          until: new Date(counter.attr("data-until")*1000),
          format: 'dhMS',
          compact: true,
          serverSync: serverTime,
          layout: clockLayout,
          onTick: doOnCounterTick,
          onExpiry: function() {
            if (expiry_callback != undefined) {
              expiry_callback();
            }
          }
        });
      }
    });
    setTimeout(callback, 0);
    $.countdown.startCountdown();
  }



  function setup_with_clocks_b_variant(callback, expiry_callback) {
    var lang = $('body').data('lang'),
        defaultRegionalOptions = $.countdown.regionalOptions[''],
        regionalOptions = $.countdown.regionalOptions[lang] || defaultRegionalOptions,
        timeLabels = compactTimeLabels(regionalOptions['labels']);

    regionalOptions['compactLabels'] = regionalOptions['compactLabels'].concat(timeLabels)
    $.countdown.setDefaults(regionalOptions);

    var clockLayout = '{d<}{dn}{dl} {d>}{h<}{hn}{hl} {h>}{m<}{mnn}{ml} {m>}{snn}{sl}',
        elems = $("#lot_list div.cw-item-auctionlot:not(.deactivated,.lot_state_closed) span.counter, #cw-main section.bid_block:not(.deactivated) strong.counter, #suggested_lots span.counter");
    elems.each(function() {
      var counter = $(this);
      if (!counter.attr('data-lot-closed-at') && counter.attr("data-until")) {
        counter.countdown({
          until: new Date(counter.attr("data-until")*1000),
          format: 'dhMS',
          compact: true,
          serverSync: serverTime,
          layout: clockLayout,
          onTick: doOnCounterTick,
          onExpiry: function() {
            if (expiry_callback != undefined) {
              expiry_callback();
            }
          }
        });
      }
    });
    setTimeout(callback, 0);
    $.countdown.startCountdown();
  }



  /**
   *  The l10n for jquery.countdown does not include compact labels (h, m and s),
   *  this method adds compact labels based on the existing labels.
   */
  function compactTimeLabels(labels) {
    var extractCompactLabel = function(idx) {
      var label,
          timeUnit = labels[idx];
      if (timeUnit !== undefined) {
        var lowerCaseTimeUnit = timeUnit.toLowerCase();
        // For latin locales get first char of time unit, for non-latin locale
        // return the timeunit.
        label = timeUnit !== lowerCaseTimeUnit ? lowerCaseTimeUnit[0] : timeUnit
      }
      return label;
    }

    var hours = extractCompactLabel(4),
        minutes = extractCompactLabel(5),
        seconds = extractCompactLabel(6);
    return [hours, minutes, seconds];
  }



  function on_lot_close_callback() {
    if (lot_is_closed()) {
      return;
    }

    window.setTimeout(function(){
      if (lot_is_closed()) {
        return;
      }
      window.location.reload()
    }, 15000);
  }

  function on_offer_close_callback() {
    $('.bid_block').removeClass('lot_state_highest_bid_offer')
  }



  function lot_is_closed() {
    return $('.bid_block').hasClass('lot_state_closed');
  }

  function lot_has_highest_bid_offer() {
    return $('.bid_block').hasClass('lot_state_highest_bid_offer');
  }

  function lot_bidding_started() {
    return $('.bid_block').hasClass('lot_state_bidding_started');
  }



  function setup (on_list_page, callback) {
    if (callback == null) callback = function () {};
    is_on_list_page = on_list_page;
    if(navigator.appName.indexOf("Internet Explorer")!=-1){     //yeah, he's using IE
      var badBrowser=(
        navigator.appVersion.indexOf("MSIE 9")==-1 &&   //v9 is ok
        navigator.appVersion.indexOf("MSIE 1")==-1);    //v10, 11, 12, etc. is fine too
    }
    if (badBrowser && on_list_page){
      setup_without_clocks(callback);
    }
    else {
      window.setTimeout(function () {
        var expiry_callback;
        if (!on_list_page && lot_bidding_started() && !lot_is_closed()) {
          expiry_callback = on_lot_close_callback;
        }
        else if (!on_list_page && lot_has_highest_bid_offer()) {
          expiry_callback = on_offer_close_callback;
        }
        setup_with_clocks(callback, expiry_callback);
      },100);
    }
  }



  // exports
  return {
    setup: setup
  };

});
